export default class CookieHelper {

    static set(name, value, expireInDays, path = "/") {
        const date = new Date();
        date.setTime(date.getTime() + (expireInDays * 24 * 60 * 60 * 1000));
        document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + '; path=' + path;
    }

    static get(name) {
        const cookieName = name + '=';
        const allCookieArray = document.cookie.split(';');
        for (let i = 0; i < allCookieArray.length; i++) {
            const temp = allCookieArray[i].trim();
            if (temp.indexOf(cookieName) === 0)
                return temp.substring(cookieName.length, temp.length);
        }
        return null;
    }

}


//export function setCookie(cookieName, cookieValue, daysToExpire) {
//    const date = new Date();
//    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
//    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toUTCString() + '; path=/';
//};

//export function getCookie(cookieName) {
//    const name = cookieName + '=';
//    const allCookieArray = document.cookie.split(';');
//    for (let i = 0; i < allCookieArray.length; i++) {
//        const temp = allCookieArray[i].trim();
//        if (temp.indexOf(name) === 0)
//            return temp.substring(name.length, temp.length);
//    }
//    return null;
//};